import { defineComponent as n, createBlock as o, openBlock as t, unref as c, mergeProps as l, withCtx as m, createElementVNode as p } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const d = /* @__PURE__ */ n({
  name: "IconCurrencyAustralianDollar",
  __name: "IconCurrencyAustralianDollar",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const r = a;
    return (i, e) => (t(), o(c(u), l(r, { "view-box": "0 0 20 20" }), {
      default: m(() => e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M15.129 4a.75.75 0 0 0-1.5 0v.314a3.693 3.693 0 0 0-1.52.611c-.675.483-1.147 1.236-1.147 2.218 0 1.031.542 1.708 1.217 2.162.43.289.95.512 1.45.705v4.148c-.945-.245-1.5-.945-1.5-1.658a.75.75 0 0 0-1.5 0c0 1.714 1.369 2.904 3 3.186V16a.75.75 0 0 0 1.5 0v-.314c1.631-.282 3-1.472 3-3.186 0-1.133-.467-1.94-1.153-2.516-.547-.46-1.226-.766-1.847-1.01V5.85a2.059 2.059 0 0 1 .647.297c.325.232.52.55.52.997a.75.75 0 0 0 1.5 0c0-.982-.473-1.735-1.148-2.218a3.693 3.693 0 0 0-1.52-.611V4m-1.5 1.849a2.059 2.059 0 0 0-.648.297c-.324.232-.519.55-.519.997 0 .397.167.657.554.918a4.034 4.034 0 0 0 .613.327v-2.54m1.5 4.753v3.556c.945-.245 1.5-.945 1.5-1.658 0-.653-.242-1.051-.618-1.368a3.892 3.892 0 0 0-.882-.53M7.156 11.75l.995 4.041a.75.75 0 0 0 1.456-.358L6.984 4.778c-.311-1.266-2.11-1.27-2.426-.005L1.894 15.43a.75.75 0 0 0 1.455.364L4.36 11.75h2.796m-.37-1.5L5.77 6.115 4.735 10.25h2.052",
          "clip-rule": "evenodd"
        }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  d as default
};
